import React from 'react';
import PropTypes from 'prop-types';
import {
  IconAppStore,
  IconCodepen,
  IconExternal,
  IconFolder,
  IconFork,
  IconGitHub,
  IconMedium,
  IconLinkedin,
  IconLoader,
  IconLocation,
  IconLogo,
  IconPlayStore,
  IconStar,
  IconTwitter,
  IconZap,
  IconBlog,
  IconScholar,
} from '@components/icons';

const Icon = ({ name }) => {
  switch (name) {
  case 'AppStore':
    return <IconAppStore />;
  case 'Codepen':
    return <IconCodepen />;
  case 'External':
    return <IconExternal />;
  case 'Folder':
    return <IconFolder />;
  case 'Fork':
    return <IconFork />;
  case 'GitHub':
    return <IconGitHub />;
  case 'Medium':
    return <IconMedium />;
  case 'Linkedin':
    return <IconLinkedin />;
  case 'Loader':
    return <IconLoader />;
  case 'Location':
    return <IconLocation />;
  case 'Logo':
    return <IconLogo />;
  case 'PlayStore':
    return <IconPlayStore />;
  case 'Star':
    return <IconStar />;
  case 'Twitter':
    return <IconTwitter />;
  case 'Zap':
    return <IconZap />;
  case 'Blog':
    return <IconBlog />;
  case 'Scholar':
    return <IconScholar />;
  default:
    return <IconExternal />;
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
